import {React,useEffect} from 'react'
import Topbar from '../../components/topbar/Topbar'
import './Error.css'
import { Link,useNavigate } from 'react-router-dom'

export default function Error2() {
    const navigate = useNavigate();
    
    useEffect(() => {
      if(window.localStorage.getItem('currentUID')){
          navigate('/');
      }
      window.document.title='SocialHub-Link Expire !';
    }, [])
    
    return (
        <>
            <Topbar />
            <div className='errorpage'>
                <div className="error">
                    <h2>Password reset link expire! <br />Reset Again</h2>
                    <Link to={'/'} style={{'width':'100%'}}><button className='rightShareBtn'>Go Back</button></Link>
                </div>
            </div>
        </>
    )
}